import React, { Component } from 'react';
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';

const containerStyle = {
  position: 'relative',
  width: '100%',
  height: '400px',
};

export class MapContainer extends Component {
  render() {
    const { pyns } = this.props;

    let items = '';
    if (pyns) {
      items = pyns.map((pyn, key) => <Marker key={pyn.address} position={{ lat: pyn.pyn.latitude, lng: pyn.pyn.longitude }} name={pyn.address} />);
    }

    return (
      <Map center={this.props.center} google={this.props.google} zoom={14} containerStyle={containerStyle}>
        <Marker onClick={this.onMarkerClick} name={'Current location'} />
        {items}
      </Map>
    );
  }
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyAbL7q4XF7cL5sAGWI0CmUHTT8KirjSMv0',
})(MapContainer);
